import { ChangeAlertCallbackType } from "../components/Root";
import { getPosition } from "./PositionService";
import * as API from '../http/api';

export class BatchService {
    private changeAlert: ChangeAlertCallbackType
    constructor(changeAlert: ChangeAlertCallbackType) {
        this.changeAlert = changeAlert
    }

    async batchNotificationGet(data) {
        const pos = getPosition();
        const response = await API.service('batchNotificationGet', data, pos, this.changeAlert, null, null);
        
        return response?.data
    }

    async batchNotificationList(data) {
        const pos = getPosition();
        const response = await API.service('batchNotificationList', data, pos, this.changeAlert, null, null);

        return response?.data
    }
    
    async batchNotificationSave(data) {
        const pos = getPosition();
        const response = await API.service('batchNotificationSave', data, pos, this.changeAlert, null, null);

        return response?.data
    }
}